/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Vocabulary } from "../../Utils/Vocabulary";
import {
  Button,
  CircularProgress,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import { toast } from "react-toastify";
import { Delete, Edit } from "@mui/icons-material";
import { LocalUrlEnum, UrlEnum } from "../../Utils/Utils";
import { updateData } from "../../Services/updateData";
import EditClientModal from "../Orders/EditClientModal";
import { getData } from "../../Services/getData";
import theme from "../../Theme/Theme";
import AddNewUser from "./AddNewUser";
import DeleteUser from "./DeleteUser";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import { useLocation, useNavigate } from "react-router-dom";
import { breadCrumbsEnum, usersTypes } from "../../Utils/Constants";

type UsersProps = {
  type: string;
};
export default function Users(props: UsersProps) {
  const { type } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const notifyError = (message: string) => toast.error(message);
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [editClientModal, setEditClientModal] = useState<{ open: boolean; user: any | null }>({
    open: false,
    user: null,
  });
  const [state, setState] = useState<any>({
    users: [],
    count: 0,
    page: 0,
    perPage: 10,
    search: null,
    type: type,
  });

  useEffect(() => {
    const search = location.search.split("?");
    const newState: any = {
      users: [],
      count: 0,
      page: 0,
      perPage: 10,
      search: null,
      type: type,
    };
    search.forEach((value) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "page") newState[values[0]] = +values[1] - 1;
        else newState[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
      }
    });
    getUsers(newState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, shouldUpdate]);

  useEffect(() => {
    breadCrumbsContext.setBreadCrumbs([breadCrumbsEnum.users]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   *
   */
  function getUsers(newState: any) {
    setLoading(true);
    let url = `${UrlEnum.users}/${newState.type}/${newState.page}/${newState.perPage}`;
    if (newState.search) {
      url = `${UrlEnum.users}/${newState.type}/${newState.page}/${newState.perPage}/${newState.search}`;
    }
    getData(url)
      .then((res) => {
        setState({
          ...state,
          users: res.data.users,
          count: res.data.usersNumber,
          page: newState.page,
          perPage: newState.perPage,
          search: newState.search,
          type: newState.type,
        });
        setLoading(false);
      })
      .catch((err) => {
        notifyError(Vocabulary.getError);
        setLoading(false);
      });
  }

  /**
   *
   */
  const handleOpenAddUserModal = async () => {
    setOpenAddUserModal(true);
    setSelectedRow(null);
  };
  /**
   *
   * @param {*} row
   */
  const onDeleteUser = async (row: any) => {
    setDeleteId(row.id);
    setShowDeleteUserModal(true);
  };

  /**
   *
   * @param {*} row
   */
  const onEditUser = async (row: any) => {
    setSelectedRow(row);
    setOpenAddUserModal(true);
  };
  /**
   *
   * @param role
   * @returns
   */
  function getRolesName(role: string) {
    if (role === "admin") return Vocabulary.admin;
    else if (role === "user") return Vocabulary.user;
    else if (role === "serviceTechnician") return Vocabulary.serviceTechnician;
  }

  //
  const requestHeadersForUsers = [
    {
      label: Vocabulary.name.toUpperCase(),
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.email.toUpperCase(),
      name: "email",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.roles.toUpperCase(),
      name: "role",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: string) => (
          <div style={{ whiteSpace: "pre" }}>{getRolesName(value)}</div>
        ),
      },
    },

    {
      label: Vocabulary.options.toUpperCase(),
      name: "optiuni",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => (
          <div style={{ marginTop: -10, marginBottom: -10 }}>
            <ToggleButtonGroup exclusive aria-label="text alignment">
              <Tooltip title={Vocabulary.edit}>
                <ToggleButton
                  onClick={() => {
                    onEditUser(state.users[rowIndex]);
                  }}
                  value="center"
                  aria-label="centered"
                >
                  <Edit />
                </ToggleButton>
              </Tooltip>
              <Tooltip title={Vocabulary.delete}>
                <ToggleButton
                  onClick={(event) => {
                    event.stopPropagation();
                    onDeleteUser(state.users[rowIndex]);
                  }}
                  value="center"
                  aria-label="centered"
                >
                  <Delete />
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          </div>
        ),
      },
    },
  ];

  //
  const requestHeadersForCustomers = [
    {
      label: Vocabulary.name.toUpperCase(),
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.email.toUpperCase(),
      name: "email",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.phone.toUpperCase(),
      name: "personalData",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (personalData: any) => (
          <div style={{ whiteSpace: "pre" }}>
            {personalData ? personalData.phoneNumber : ""}
          </div>
        ),
      },
    },
    {
      label: Vocabulary.options.toUpperCase(),
      name: "optiuni",
      options: {
        setCellHeaderProps: () => ({ align: "center" }),
        setCellProps: () => ({ align: "center" }),
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (_dataIndex: any, rowIndex: any) => (
          <Tooltip title={Vocabulary.edit}>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setEditClientModal({ open: true, user: state.users[rowIndex] });
              }}
            >
              <Edit />
            </IconButton>
          </Tooltip>
        ),
      },
    },
  ];

  /**
   *
   * @returns
   */
  function getTableOptions() {
    const responsive: "standard" | "vertical" | "simple" | undefined =
      "standard";
    return {
      selectableRows: "none" as any,
      viewColumns: false as any,
      responsive: responsive,
      rowsPerPageOptions: [10, 20, 50, 100],
      confirmFilters: true,
      filter: false,
      print: false,
      download: false,
      textLabels: {
        body: {
          noMatch: Vocabulary.noResultsFound,
        },
      },
      rowsPerPage: state.perPage,
      count: state.count,
      page: state.page,
      search: true,
      serverSide: true,
      sort: true,
      setRowProps: () => {
        if (state.type === usersTypes.customers) return {};
        return {
          style: {
            cursor: "pointer",
          },
        };
      },
      customToolbar: () => {
        if (state.type === usersTypes.customers) return null;
        return (
          <Button
            variant="contained"
            size="large"
            style={{
              color: theme.palette.whiteColor?.main,
              backgroundColor: theme.palette.dashboard?.main,
            }}
            onClick={handleOpenAddUserModal}
          >
            {Vocabulary.newUser}
          </Button>
        );
      },
      onRowClick: (rowData: any, rowState: any) => {
        if (state.type === usersTypes.customers) {
          return;
        }
        onEditUser(state.users[rowState.rowIndex]);
      },
      onChangePage: (page: any) => {
        setState({ ...state, page: page });
        navigate(
          `${LocalUrlEnum.users}?type=${state.type}?page=${page + 1}?perPage=${
            state.perPage
          }`
        );
        window.scrollTo(0, 0);
      },
      onChangeRowsPerPage: (numberOfRows: number) => {
        setState({ ...state, perPage: numberOfRows });
        navigate(
          `${LocalUrlEnum.users}?type=${state.type}?page=${1}?perPage=${numberOfRows}`
        );
        window.scrollTo(0, 0);
      },
      onSearchChange: (search: string | null) => {
        if (search) {
          navigate(
            `${LocalUrlEnum.users}?type=${state.type}?page=${1}?perPage=${
              state.perPage
            }?search=${search}`
          );
          window.scrollTo(0, 0);
        } else {
          navigate(
            `${LocalUrlEnum.users}?type=${state.type}?page=${1}?perPage=${
              state.perPage
            }`
          );
          window.scrollTo(0, 0);
        }
      },
      onSearchClose: () => {
        navigate(
          `${LocalUrlEnum.users}?type=${state.type}?page=${1}?perPage=${
            state.perPage
          }`
        );
        window.scrollTo(0, 0);
      },
    };
  }

  return (
    <>
      <MUIDataTable
        title={Vocabulary.users}
        data={state.users}
        columns={
          state.type === usersTypes.customers
            ? requestHeadersForCustomers
            : requestHeadersForUsers
        }
        options={getTableOptions()}
      />
      <AddNewUser
        showAddUserModal={openAddUserModal}
        handleCloseAddUserModal={() => setOpenAddUserModal(false)}
        handleUpdateUsersTable={() => setShouldUpdate(!shouldUpdate)}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setLoading={setLoading}
      />
      <DeleteUser
        showDeleteUserModal={showDeleteUserModal}
        setShowDeleteUserModal={setShowDeleteUserModal}
        handleUpdateUsersTable={() => setShouldUpdate(!shouldUpdate)}
        setLoading={setLoading}
        userId={deleteId}
      />
      <EditClientModal
        open={editClientModal.open}
        customer={editClientModal.user}
        onClose={() => setEditClientModal({ open: false, user: null })}
        onSave={async (customer) => {
          await updateData(`${UrlEnum.users}/${editClientModal.user._id}`, {
            name: customer.name,
            email: customer.email,
            personalData: customer.personalData,
          });
          setState((prev: any) => ({
            ...prev,
            users: prev.users.map((u: any) =>
              u._id === editClientModal.user._id ? { ...u, ...customer } : u
            ),
          }));
        }}
      />
      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
